// NOTE This file is auto-generated by Contentlayer

export { isType } from 'contentlayer/client'

// NOTE During development Contentlayer imports from `.mjs` files to improve HMR speeds.
// During (production) builds Contentlayer it imports from `.json` files to improve build performance.
import allDocs from './Doc/_index.json' assert { type: 'json' }
import allGuides from './Guide/_index.json' assert { type: 'json' }
import allRecipes from './Recipe/_index.json' assert { type: 'json' }
import allChangelogs from './Changelog/_index.json' assert { type: 'json' }
import allBlogs from './Blog/_index.json' assert { type: 'json' }
import allTutorials from './Tutorial/_index.json' assert { type: 'json' }
import allFigmas from './Figma/_index.json' assert { type: 'json' }

export { allDocs, allGuides, allRecipes, allChangelogs, allBlogs, allTutorials, allFigmas }

export const allDocuments = [...allDocs, ...allGuides, ...allRecipes, ...allChangelogs, ...allBlogs, ...allTutorials, ...allFigmas]
